import React from 'react';
import { useTranslation } from 'react-i18next';
import { IBillingInfo, IPaybPayment } from '@global/types/types';
import { CountryService } from '@global/utils/CountryService';
import { store } from '@global/store/store';
import { RootState } from '@global/store/store';

interface BillingInfoSummaryProps {
  billingInfo: IBillingInfo;
  paymentInfo: IPaybPayment;
}

export const BillingInfoSummary = ({
  billingInfo,
  paymentInfo,
}: BillingInfoSummaryProps) => {
  const { t } = useTranslation();
  const { country: countryState } = store.getState() as RootState;

  if (!billingInfo?.addressOne) return null;
  const { name, tel, zip, country, state, city, addressOne, addressTwo } =
    billingInfo;

  const countryObj = country?.iso2Code
    ? CountryService.getCountryByIsoCode(
        countryState.countries,
        country.iso2Code
      )
    : undefined;

  const displayState =
    countryObj && state
      ? CountryService.convertChinaStateCodeForDisplay(countryObj, state)
      : state;

  return (
    <div className="checkout__selected-values">
      <div>{name}</div>
      <div>{addressOne}</div>
      {addressTwo ? <div>{addressTwo}</div> : null}
      <div>
        {city}, {displayState} {zip}
      </div>
      <div>{country.name}</div>
      <div>Phone number: {tel}</div>
      {paymentInfo?.ccpaCardNumber ? (
        <div>
          {t('checkout.step2.cardEnding')}
          {paymentInfo.ccpaCardNumber.toString().slice(-4)}
        </div>
      ) : null}
    </div>
  );
};
